
const ActionCard = ({ imgSrc, altText, title, handleHistory, handleWithdraw }) => {

  // Map action titles to their respective handler functions, including translations.
  const actions = {
    History: handleHistory,
    Withdraw: handleWithdraw,
    'हिस्ट्री': handleHistory,
    'विथड्रॉ': handleWithdraw,
  };

   /**
   * Handles the click event on the card.
   * It checks the `title` and calls the corresponding function if it exists.
   */
  const handleClick = () => {
    actions[title]?.(); // Calls the action function if the title matches a key in `actions`
  };

  return (
    <div
      className="flex flex-col items-center p-4 border border-[#E2A32C] rounded-lg cursor-pointer"
      onClick={handleClick}
    >
      {/* Display action image */}
      <img src={imgSrc} alt={altText} className="h-12 w-auto mb-2" />

       {/* Display action title */}
      <p className="text-white text-[16px] font-medium">{title}</p>
    </div>
  );
};

export default ActionCard;
